module.exports = __webpack_public_path__ + "static/sourceenergy-logo-e6920e0d8fc5c405e9ce8293ae27b37b.png";